import { Fragment, useEffect } from "react";
import { useAuth } from "@belray-ventec/platform-session";
import "@/utils/firebase/firebaseConfig";
import { identifyUser } from "./analytics";

const FirebaseProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, session } = useAuth();

  useEffect(() => {
    if (user?.id) {
      identifyUser(user.id, {
        user_zone: session?.zone || "",
        user_role: user.tribolabConfig?.role?.label || "",
        platform: "tribolab",
      });
    }
  }, [user?.id, session?.zone, user?.tribolabConfig?.role?.label]);

  return <Fragment>{children}</Fragment>;
};

export default FirebaseProvider;
